import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";

import "@fortawesome/fontawesome-free/css/all.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// Load connection from appsettings.json before rendering (api.js reads from localStorage)
async function init() {
  try {
    const publicUrl = process.env.PUBLIC_URL || "";
    const res = await fetch(`${publicUrl}/appsettings.json?v=${Date.now()}`);
    const data = await res.json();
    const cfg = data.config && data.config[0];
    if (cfg) {
      if (cfg.API_URL) localStorage.setItem("API_URL", cfg.API_URL);
      if (cfg.WEB_URL) localStorage.setItem("WEB_URL", cfg.WEB_URL);
      if (cfg.SESSION_IDLE_MINUTES) localStorage.setItem("SESSION_IDLE_MINUTES", cfg.SESSION_IDLE_MINUTES);
      if (cfg.SESSION_PROMPT_MINUTES) localStorage.setItem("SESSION_PROMPT_MINUTES", cfg.SESSION_PROMPT_MINUTES);
      if (cfg.APP_VERSION) {
        // Store the current version if not already set
        if (!localStorage.getItem("APP_VERSION")) {
          localStorage.setItem("APP_VERSION", cfg.APP_VERSION);
        }
        // Always store the latest server version for comparison
        localStorage.setItem("APP_VERSION_SERVER", cfg.APP_VERSION);
      }
    }
  } catch (e) {
    console.warn("Could not load appsettings.json", e);
  }

  const { default: App } = await import("./App");
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  reportWebVitals();
}

init();
